import type { Editor } from "@tiptap/react";
import type { LucideIcon } from "lucide-react";
import {
  Heading2,
  Heading3,
  List,
  ListOrdered,
  TextQuote,
  Code,
  ImageIcon,
  Minus,
} from "lucide-react";

export interface SlashCommandItem {
  title: string;
  description: string;
  icon: LucideIcon;
  command: (editor: Editor) => void;
}

export function createSlashCommandItems(
  onImageUpload?: (file: File) => Promise<string>,
): SlashCommandItem[] {
  const items: SlashCommandItem[] = [
    {
      title: "Heading 2",
      description: "중간 크기 제목",
      icon: Heading2,
      command: (editor) =>
        editor.chain().focus().toggleHeading({ level: 2 }).run(),
    },
    {
      title: "Heading 3",
      description: "작은 크기 제목",
      icon: Heading3,
      command: (editor) =>
        editor.chain().focus().toggleHeading({ level: 3 }).run(),
    },
    {
      title: "Bullet List",
      description: "순서 없는 목록",
      icon: List,
      command: (editor) => editor.chain().focus().toggleBulletList().run(),
    },
    {
      title: "Ordered List",
      description: "순서 있는 목록",
      icon: ListOrdered,
      command: (editor) => editor.chain().focus().toggleOrderedList().run(),
    },
    {
      title: "Quote",
      description: "인용구 블록",
      icon: TextQuote,
      command: (editor) => editor.chain().focus().toggleBlockquote().run(),
    },
    {
      title: "Code Block",
      description: "코드 블록",
      icon: Code,
      command: (editor) => editor.chain().focus().toggleCodeBlock().run(),
    },
    {
      title: "Divider",
      description: "구분선",
      icon: Minus,
      command: (editor) => editor.chain().focus().setHorizontalRule().run(),
    },
  ];

  if (onImageUpload) {
    items.push({
      title: "Image",
      description: "이미지 업로드",
      icon: ImageIcon,
      command: (editor) => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.onchange = async (e) => {
          const file = (e.target as HTMLInputElement).files?.[0];
          if (!file) return;

          try {
            const url = await onImageUpload(file);
            if (!url) return;
            editor.chain().focus().setImage({ src: url }).run();
          } catch {
            // 에러는 upload hook에서 toast로 처리됨
          }
        };
        input.click();
      },
    });
  }

  return items;
}
